import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/Badge';
import { simplifiedPosterHoverEnabled } from 'helpers/ConfigHelper';
import Overlay from '../Overlay';

const PosterContent = props => {
  const [isHover, setIsHover] = useState(false);
  const [play, setPlay] = useState(false);
  const isSimplifiedHoverEnabled = simplifiedPosterHoverEnabled();

  const {
    badge,
    hasOverlay,
    image,
    isHoverStateV2,
    noPreview,
    renderImage,
    segmentPlaylistButtonAction,
    theme,
    video,
  } = props;
  const posterImage = renderImage(image);

  const handleMouseEnter = () => {
    if (video) {
      setPlay(true);
    }
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
    setPlay(false);
  };

  const posterHoverProps = {
    onMouseEnter: () => handleMouseEnter(),
    onMouseLeave: () => handleMouseLeave(),
  };

  if (!hasOverlay) return posterImage;

  return (
    <div className={theme.posterContents} {...posterHoverProps}>
      {noPreview ? (
        <Overlay
          {...props}
          isHover={isHover}
          play={play}
          segmentPlaylistButtonAction={segmentPlaylistButtonAction}
        />
      ) : (
        <>
          {isSimplifiedHoverEnabled ? (
            <div className={theme.simplifiedHover}>{posterImage}</div>
          ) : (
            <div className={isHover ? theme.invisible : ''}>{posterImage}</div>
          )}
          <div className={!isHover ? theme.invisible : ''}>
            <Overlay {...props} isHover={isHover} play={play} />
            <Badge
              isPoster
              badge={badge}
              title={video?.seriesName}
              isHoverStateV2={isHoverStateV2}
              theme={theme}
            />
          </div>
        </>
      )}
    </div>
  );
};

PosterContent.defaultProps = {
  badge: '',
  hasOverlay: false,
  image: '',
  isHoverStateV2: false,
  item: {},
  noPreview: false,
  renderImage: () => {},
  segmentPlaylistButtonAction: () => {},
  theme: {},
  video: null,
};

PosterContent.propTypes = {
  badge: PropTypes.string,
  hasOverlay: PropTypes.bool,
  image: PropTypes.string,
  isHoverStateV2: PropTypes.bool,
  item: PropTypes.shape({}),
  noPreview: PropTypes.bool,
  renderImage: PropTypes.func,
  segmentPlaylistButtonAction: PropTypes.func,
  theme: PropTypes.shape({}),
  video: PropTypes.string,
};

export default PosterContent;
